import { useAccounts } from "@api/v1/hooks/useAccounts";
import { useGetWealthApiBankConnections } from "@features/settings/useSettings";
import { useListAndSearchAllBankConnectionsV2 } from "@bn/api/apiv1";
import { transformBankConnection } from "./helpers";

export const useBankConnections = () => {
  const { data: accounts } = useAccounts();
  const wealthApiConnectionIds = accounts?.accounts?.reduce(
    (acc, account) =>
      account.bankConnectionType === "WEALTH_API" &&
      account.bankConnectionId &&
      !acc.includes(account.bankConnectionId)
        ? [...acc, account.bankConnectionId]
        : acc,
    [] as number[]
  );

  const { data } = useListAndSearchAllBankConnectionsV2();
  const finApiBankConnections = data?.bankConnections?.map(
    transformBankConnection
  );

  const { data: wealthApiBankConnections } = useGetWealthApiBankConnections(
    {
      filterId: (wealthApiConnectionIds || []).join(","),
    },
    {
      enabled: Boolean(wealthApiConnectionIds?.length),
    }
  );

  const finApiConnectionHasAccountsMap = (accounts?.accounts ?? []).reduce(
    (acc, account) => {
      if (
        account.bankConnectionType === "FIN_API" &&
        account.bankConnectionId != null
      ) {
        acc.set(account.bankConnectionId, true);
      }
      return acc;
    },
    new Map<number, boolean>()
  );

  const finApiConnections = (finApiBankConnections ?? []).map((conn) => ({
    ...conn,
    hasNoAccounts: !finApiConnectionHasAccountsMap.get(conn.id),
  }));

  return {
    finApiBankConnections: finApiConnections,
    wealthApiBankConnections: wealthApiBankConnections || [],
  };
};
